import { FlexBox } from '@dixa/lib-shared-habla';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableQueue.module.scss';

/** Represents the content of the queue cell in the conversations table. */
export const ConversationsTableQueue = (): JSX.Element => {
  const {
    conversationAndRequester: { conversation },
  } = useConversationRow();

  // TODO: Implement  presentation
  return (
    <FlexBox alignItems="center">
      {conversation.queue ? (
        conversation.queue.name
      ) : (
        <em className={styles.notInQueue}>Not in a queue</em>
      )}
    </FlexBox>
  );
};
